<script>
	import { pageNumber, model } from "../../stores";

	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import Notice from "./components/Notice.svelte";

	export let disabled = null;
	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let title = null;

	let stage = "PersonalDetails";

	let directorName = null;
	let executorName = null;
	let poaName = null;
	let solicitorName = null;

	if (!disabled) {
		$pageNumber = pageIndex;
		document.title = pageTitle;
	}

	$model.IsOptOut = true;

	const beforeSubmit = () => {
		switch ($model.OptOut.OptOutType) {
			case "Group Member":
				$model.Claimant.FirstName = $model.Contact.FirstName;
				$model.Claimant.Surname = $model.Contact.Surname;
				break;
			case "Director":
				$model.Claimant.Surname = directorName;
				break;
			case "Executor":
				$model.Claimant.Surname = executorName;
				break;
			case "Power of Attorney":
				$model.Claimant.Surname = poaName;
				break;
			case "Solicitor":
				$model.Claimant.Surname = solicitorName;
				break;
		}
		$model.Claimant.OptOutType = $model.OptOut.OptOutType || "Group Member";

		return true;
	};
</script>

<PageSection>
	<div class="row justify-content-center">
		<div class="col-md-12">
			<h2 class="text-center">Nuix Shareholder Class Action</h2>
			<h1 class="text-center">Please provide your details</h1>
		</div>
	</div>

	<hr style="border-color:#E6692D" />

	<Notice {disabled} {stage} bind:directorName bind:executorName bind:poaName bind:solicitorName />

	{#if !disabled}
		<div class="form-group form-row">
			<div class="col-md-12 last">
				<NavigationButtons
					validate
					{previousPage}
					{nextPage}
					pageName={title}
					{persistUrl}
					tealiumTag={true}
					{beforeSubmit}
				></NavigationButtons>
			</div>
		</div>
	{/if}
</PageSection>
